export type ErrorFieldStringProps = {
  error?: string;
};
const ErrorFieldString: React.FC<ErrorFieldStringProps> = ({ error = 'Check field' }) => (
  <span className="block mt-14 text-14 text-red">{error}</span>
);

export default ErrorFieldString;
